import Vue from "vue";
import noimage from "../assets/noimage.png";
/* eslint-disable */
Vue.mixin({
  methods: {
    capitalizeFirstLetter(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    imageLoadError(event) {
      event.target.src = noimage;
    },
    checkLink(item) {
      var idSchema, check;
      var id = item.id;
      var title = item.data.title;

      var link;

      if (item.idSchema == "205" || item.idSchema == "206") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "205") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "207") {
        //news
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "208") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "209") {
        //news
        idSchema = "209";
        // console.log(JSON.stringify(item, null, 2));
        link = "/play?scheme=209&p_type=false&id=" + item.id + "&eps_id=";
      } else if (item.idSchema == "203") {
        //news
        idSchema = "209";
        // console.log(JSON.stringify(item, null, 2));
        link = "/podcastplayer?id=" + item.id;
      } else if (idSchema == "204") {
        //pod episode
        link = "/podcastplayer?id=" + item.id;
      }

      return link;
    },
    mastheadImgFiltering(item) {
      var imgurl;
      //check if
      var checkThumbnail =
        item.data && item.data.images && item.data.images.thumbnail;
      var checkTitle = item.data && item.data.images && item.data.images.title;
      var checkImgFeature =
        item.data && item.data.images && item.data.images.feature;

      if (checkThumbnail) {
        imgurl =
          "https://rtb.glueapi.io/v1/content/" + item.id + "/image/240x0/images.thumbnail";
      } else {
        if (checkTitle) {
          imgurl =
            "https://rtb-images.glueapi.io/240x0/" +
            item.data.images.title.path;
        } else {
          if (checkImgFeature) {
            imgurl =
              "https://rtb-images.glueapi.io/240x0/" +
              item.data.images.feature.path;
          } else {
            imgurl =
              "https://rtb.glueapi.io/v1/content/" +
              item.id +
              "/image/240x0/images.title";
          }
        }
      }
      return imgurl;
    },
    imgFiltering(item, type = null) {
      let imgurl;
      const hasThumb =
        item.data && item.data.images && item.data.images.thumbnail;
      const hasTitle = item.data && item.data.images && item.data.images.title;
      const hasFeature =
        item.data && item.data.images && item.data.images.feature;

      // First try to get the specifically requested type if it exists
      if (type === "thumbnail" && hasThumb) {
        imgurl =
          "https://rtb.glueapi.io/v1/content/" + item.id + "/image/320x0/images.thumbnail";
      } else if (type === "title" && hasTitle) {
        imgurl =
          "https://rtb-images.glueapi.io/320x0/" + item.data.images.title.path;
      } else if (type === "feature" && hasFeature) {
        imgurl =
          "https://rtb-images.glueapi.io/320x0/" +
          item.data.images.feature.path;
      }
      // Fall back to original hierarchy if requested type doesn't exist or no type specified
      else {
        if (hasThumb) {
          imgurl =
            "https://rtb.glueapi.io/v1/content/" + item.id + "/image/320x0/images.thumbnail";
        } else if (hasTitle) {
          imgurl =
            "https://rtb-images.glueapi.io/320x0/" +
            item.data.images.title.path;
        } else if (hasFeature) {
          imgurl =
            "https://rtb-images.glueapi.io/320x0/" +
            item.data.images.feature.path;
        } else {
          imgurl =
            "https://rtb.glueapi.io/v1/content/" +
            item.id +
            "/image/300x0/images.title";
        }
      }

      return imgurl;
    },
    getRadioImgForMasthead(id) {
      const x = id;
      switch (true) {
        case x == 7:
          return "../assets/radio/Pilihan.png";
        case x == 6:
          return "../assets/radio/Pelangi.png";
        case x == 5:
          return "../assets/radio/NurIslam.png";
        case x == 4:
          return "../assets/radio/Nasional.png";
        case x == 3:
          return "../assets/radio/Harmoni.png";
      }
    },
    initializePlayer(value, target, type) {
      var gluePlayer = new GluePlyr();
      gluePlayer.setup(value, {
        apiPath: "https://rtb.glueapi.io",
        target: target,
        poster:
          "https://rtb.glueapi.io/v1/content/" +
          value +
          "/image/1200x0/images.title?quality=100", //Replace with the id 413 with the id of the content
        site: "RTBGo",
        type: type, // video or audio
        playerMode: type === "audio" ? "radio" : "vod",
        casting: "D6AD19DD",
        skin: "title", // false or title (Tile Skin is used for creating player with title image
      });

      window.gluePlayer = gluePlayer;

      this.currenturl = window.location.origin + "" + this.$route.path;

      this.childDataLoaded = true;
    },
    initializePlayerWithAds(value, target, type) {
      let adTagRule;

      if (value === 2) {
        adTagRule =
          "https://pubads.g.doubleclick.net/gampad/live/ads?iu=/22163595876/RTBGo_Web_Preroll_Live_Sukmaindera&description_url=https%3A%2F%2Fwww.rtbgo.bn%2Flive%2FSUKMAINDERA&tfcd=0&npa=0&sz=400x300%7C640x480%7C1920x1080&gdfp_req=1&output=vast&unviewed_position_start=1&env=vp&impl=s&correlator=";
      } else if (value === 3391) {
        adTagRule =
          "https://pubads.g.doubleclick.net/gampad/live/ads?iu=/22163595876/RTBGo_Web_Preroll_Live_Aneka&description_url=https%3A%2F%2Fwww.rtbgo.bn%2Flive%2FANEKA&tfcd=0&npa=0&sz=400x300%7C640x480%7C1920x1080&gdfp_req=1&output=vast&unviewed_position_start=1&env=vp&impl=s&correlator=";
      } else if (value === 1229) {
        adTagRule =
          "https://pubads.g.doubleclick.net/gampad/live/ads?iu=/22163595876/RTBGo_Web_Preroll_Live_GoLive&description_url=https%3A%2F%2Fwww.rtbgo.bn%2Flive%2FGOLIVE&tfcd=0&npa=0&sz=400x300%7C640x480%7C1920x1080&gdfp_req=1&output=vast&unviewed_position_start=1&env=vp&impl=s&correlator=";
      } else {
        adTagRule =
          "https://pubads.g.doubleclick.net/gampad/live/ads?iu=/22163595876/RTBGo_Web_Preroll_Live_Sukmaindera&description_url=https%3A%2F%2Fwww.rtbgo.bn%2Flive%2FSUKMAINDERA&tfcd=0&npa=0&sz=400x300%7C640x480%7C1920x1080&gdfp_req=1&output=vast&unviewed_position_start=1&env=vp&impl=s&correlator=";
      }

      var gluePlayer = new GluePlyr();
      gluePlayer.setup(value, {
        apiPath: "https://rtb.glueapi.io",
        target: target,
        poster:
          "https://rtb.glueapi.io/v1/content/" +
          value +
          "/image/1200x0/images.title?quality=100", //Replace with the id 413 with the id of the content
        site: "RTB",
        // psa: true,
        type: type, // video or audio
        playerMode: "live",
        skin: "0", // false or title (Tile Skin is used for creating player with title image
        // casting: "D6AD19DD",
        ads: {
          enabled: true,
          tagUrl: adTagRule,
          contentType: "ondemand",
          cmsid: "glue",
          vid: value,
          keywords: "",
        },
      });

      window.gluePlayer = gluePlayer;

      this.currenturl = window.location.origin + "" + this.$route.path;

      this.childDataLoaded = true;
    },
    convertTimestamp(time) {
      var date = new Date(time);
      return date.getTime();
    },
    formatTimestamp(dt) {
      var result;
      var t = new Date(dt);
      var dtplustwo =
        t.getFullYear() +
        "-" +
        (t.getMonth() + 1) +
        "-" +
        (t.getDate() + 2) +
        " 00:00";
      dtplustwo = new Date(dtplustwo).getTime();
      // console.log(t);
      var today = new Date();
      var date =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate() +
        " 00:00";

      var twodays =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        (today.getDate() + 2) +
        " 00:00";
      var from = new Date(date).getTime(); //today
      var twodaysafter = new Date(twodays).getTime(); //twodaysfromtodaay
      if (dtplustwo >= from && dtplustwo <= twodaysafter) {
        result = true;
      } else {
        result = false;
      }

      return result;
    },
    formatString(str) {
      // var lower = str.toLowerCase();
      // return lower
      //   .toLowerCase()
      //   .split(" ")
      //   .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      //   .join(" ");
      return str;
    },
    deviceCheck() {
      if (this.$device.ipad) {
        this.tablet = true;
      } else if (this.$device.mobile) {
        this.mobile = true;
      } else {
        this.desktop = true;
      }
    },
  },
});
